<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Tạo sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>

                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataStore.store_name.label"
                                        :id="dataStore.store_name.id"
                                        :placeholder="dataStore.store_name.placeholder"
                                        :value-default="dataStore.store_name.value"
                                        @inputValue="onChange($event, dataStore.store_name.id)"
                                        :error-text="dataStore.store_name.error"
                                        :is-error="dataStore.store_name.isError"
                                        @blur="validateForm($event, dataStore.store_name.id)"
                                        :required="dataStore.store_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataStore.store_code.label"
                                        :id="dataStore.store_code.id"
                                        :placeholder="dataStore.store_code.placeholder"
                                        :value-default="dataStore.store_code.value"
                                        @inputValue="onChange($event, dataStore.store_code.id)"
                                        :error-text="dataStore.store_code.error"
                                        :is-error="dataStore.store_code.isError"
                                        @blur="validateForm($event, dataStore.store_code.id)"
                                        :required="dataStore.store_code.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataStore.store_phone.label"
                                        :id="dataStore.store_phone.id"
                                        :placeholder="dataStore.store_phone.placeholder"
                                        :value-default="dataStore.store_phone.value"
                                        @inputValue="onChange($event, dataStore.store_phone.id)"
                                        :error-text="dataStore.store_phone.error"
                                        :is-error="dataStore.store_phone.isError"
                                        @blur="validateForm($event, dataStore.store_phone.id)"
                                        :required="dataStore.store_phone.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataStore.store_addr.label"
                                        :id="dataStore.store_addr.id"
                                        :placeholder="dataStore.store_addr.placeholder"
                                        :value-default="dataStore.store_addr.value"
                                        @inputValue="onChange($event, dataStore.store_addr.id)"
                                        :error-text="dataStore.store_addr.error"
                                        :is-error="dataStore.store_addr.isError"
                                        @blur="validateForm($event, dataStore.store_addr.id)"
                                        :required="dataStore.store_addr.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createOrUpdateStore"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
